<template>
  <v-card class="d-flex align-center justify-center pa-5" outlined style="background-color: rgba(0,0,0,0); min-height: 70vh;">
    <v-container v-if="adminUser" fluid>
      <div class="d-flex justify-center">
        <v-img class="mb-5" position="center center" src="https://swiset.com/wp-content/uploads/2021/01/Tournaments-Ranking-Swiset.png" max-width="91px" contain/>
      </div>
      <h1 class="text-center">{{ $t('planning') }}</h1>
      <h3 class="text-center">{{ $t('description', { value: $store.state.tournament.participants.length })}}</h3>
      <v-row class="mt-7" align="center" justify="center">
        <v-btn class="button-participants" @click="goToParticipants">
          {{ $t('btnGo') }} <v-icon class="ml-2" color="white" small>fa-users</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container v-else fluid>
      <v-overlay absolute v-model="canIRegister"><TournamentRegisterCollapsed/></v-overlay>
      <div class="d-flex justify-center">
        <v-img class="mb-5" position="center center" src="https://swiset.com/wp-content/uploads/2021/01/Tournaments-Ranking-Swiset.png" max-width="91px" contain/>
      </div>
      <h1 class="text-center">{{ $t('waiting') }}...</h1>
      <h3 class="text-center">{{ $t('beingCreated') }}</h3>
    </v-container>
  </v-card>
</template>

<script>
import TournamentRegisterCollapsed from "@/views/Tournament/components/TournamentRegisterCollapsed";
export default {
  name: "TournamentNotStarted",
  components: {TournamentRegisterCollapsed},
  props: {
    iAmParticipant: Boolean,
    currentParticipants: Number,
  },
  data() {
    return {
      adminUser: false,
      canIRegister: false,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    '$store.state.tournament': function () {
      this.init();
      this.verifyCanIRegister();
    },
    iAmParticipant() {
      this.verifyCanIRegister();
    }
  },
  methods: {
    init() {
      this.verifyAdminUser();
      this.verifyCanIRegister();
    },
    verifyCanIRegister() {
      let visibility = this.$store.state.tournament.tournamentVisibility;
      let isClubMember = this.$store.state.clubMember !== null && this.$store.state.tournament.tournamentOrganizerId === this.$store.state.clubMember.club.id;
      this.canIRegister = !this.iAmParticipant && (visibility === 'PUBLIC' || (visibility === 'PRIVATE' && isClubMember));
    },
    verifyAdminUser() {
      if(this.$store.state.tournament !== null && this.$store.state.clubMember !== null)
        this.adminUser = this.$store.state.tournament.tournamentOrganizerId === this.$store.state.clubMember.club.id &&
            (this.$store.state.clubMember.rol === 'FOUNDER') || (this.$store.state.clubMember.rol === 'ADMIN');
    },
    goToParticipants() {
      this.$emit('goToParticipants');
    },
  }
}
</script>

<i18n>
{
  "en": {
    "planning": "Planning Tournament",
    "description": "The tournament has {value} registered participants",
    "btnGo": "Go to Participants",
    "waiting": "Waiting",
    "beingCreated": "The tournament will start soon"
  },
  "es": {
    "planning": "Torneo en Planeación",
    "description": "El torneo cuenta con {value} participantes registrados",
    "btnGo": "Ir a Participantes",
    "waiting": "Esperando",
    "beingCreated": "El torneo comenzará pronto"
  }
}
</i18n>

<style scoped>
.button-participants {
  background-color: #111111 !important;
  color: #ffffff !important;
  border: #111111 solid 1px;
}
</style>
